/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface ListLocationsResponse
 */
export interface ListLocationsResponse {
    /**
     * 
     * @type {Array<Location>}
     * @memberof ListLocationsResponse
     */
    data: Array<Location>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListLocationsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListLocationsResponse interface.
 */
export function instanceOfListLocationsResponse(value: object): value is ListLocationsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListLocationsResponseFromJSON(json: any): ListLocationsResponse {
    return ListLocationsResponseFromJSONTyped(json, false);
}

export function ListLocationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLocationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(LocationFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListLocationsResponseToJSON(json: any): ListLocationsResponse {
      return ListLocationsResponseToJSONTyped(json, false);
  }

  export function ListLocationsResponseToJSONTyped(value?: ListLocationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(LocationToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

